import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

const STORAGE_KEY_TOKEN   = 're_dev_token';
const STORAGE_KEY_ACCOUNT = 're_dev_account';

export function AuthProvider({ children }) {
  const [token,   setToken]   = useState(null);
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedToken   = localStorage.getItem(STORAGE_KEY_TOKEN);
    const savedAccount = localStorage.getItem(STORAGE_KEY_ACCOUNT);
    if (savedToken && savedAccount) {
      try {
        setToken(savedToken);
        setAccount(JSON.parse(savedAccount));
      } catch {
        localStorage.removeItem(STORAGE_KEY_TOKEN);
        localStorage.removeItem(STORAGE_KEY_ACCOUNT);
      }
    }
    setLoading(false);
  }, []);

  function login(newToken, newAccount) {
    setToken(newToken);
    setAccount(newAccount);
    localStorage.setItem(STORAGE_KEY_TOKEN,   newToken);
    localStorage.setItem(STORAGE_KEY_ACCOUNT, JSON.stringify(newAccount));
  }

  function logout() {
    setToken(null);
    setAccount(null);
    localStorage.removeItem(STORAGE_KEY_TOKEN);
    localStorage.removeItem(STORAGE_KEY_ACCOUNT);
  }

  return (
    <AuthContext.Provider value={{ token, account, login, logout, loading, isAuthenticated: !!token }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
